// Shared wait budget for action/connector creation and source preparation.
export const CREATION_TIMEOUT_MS = 30 * 60 * 1000;
